if (!customElements.get("tabs-component")) {
  customElements.define(
    "tabs-component",
    class TabsComponent extends HTMLElement {
      constructor() {
        super();

        this.onClickHandler = this.onClick.bind(this);
        this.onShopifyBlockSelect = this.handleShopifyBlockSelect.bind(this);

        if (window.Shopify && Shopify.designMode) {
          document.addEventListener("shopify:block:select", this.onShopifyBlockSelect);
        }
      }

      connectedCallback() {
        this.tablist = this.querySelector('[role="tablist"]');
        this.tabs = Array.from(this.querySelectorAll('[role="tab"]'));
        this.panels = Array.from(this.querySelectorAll('[role="tabpanel"]'));
        if (this.tablist) {
          this.tablist.addEventListener("click", this.onClickHandler);
        }
      }

      disconnectedCallback() {
        if (this.tablist) {
          this.tablist.removeEventListener("click", this.onClickHandler);
        }

        if (window.Shopify && Shopify.designMode) {
          document.removeEventListener("shopify:block:select", this.onShopifyBlockSelect);
        }
      }

      onClick(e) {
        const tab = e.target.closest('[role="tab"]');
        if (!tab) return;

        const index = this.tabs.indexOf(tab);
        if (index === -1) return;

        this.activateTab(index);
      }

      activateTab(index) {
        this.tabs.forEach((tab, i) => {
          const isActive = i === index;

          tab.setAttribute("aria-selected", isActive ? "true" : "false");
          tab.tabIndex = isActive ? 0 : -1;
        });

        this.panels.forEach((panel, i) => {
          panel.hidden = i !== index;
        });
      }

      handleShopifyBlockSelect(e) {
        const blockId = e.detail.blockId;
        const panel = this.querySelector(`[data-block-id="${blockId}"]`);
        if (!panel) return;

        const index = this.panels.indexOf(panel);
        if (index !== -1) {
          this.activateTab(index);
        }
      }
    },
  );
}
